module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_027.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_027.png
// module id = 2343
// module chunks = 5